import useFAQs from "@/hooks/useFAQs";
import { Accordions } from "@/ui/Accordions";
import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { chunk } from "lodash/array";
import { useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  title,
  description,
  EditableText,
  EditableHtml,
  fullWidth = true,
  columns = 1,
  types = null,
  group = null,
  sector = null,
  theme = "light",
}) {
  const [type, setType] = useState(types ? types[0] : null);
  const items = useFAQs({ group, sector });

  const computedItems = useMemo(
    () =>
      chunk(
        items.filter((i) => (type ? i.type.includes(type) : true)),
        Math.ceil(items.length / columns),
      ),
    [items, type],
  );

  const intro = (
    <div className="mb-4">
      <EditableText path="title" tag="h2">
        {title}
      </EditableText>
      <EditableHtml path="description" className="text-balance">
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </EditableHtml>
    </div>
  );

  const buttons = (
    <>
      {types && (
        <Buttons
          className="justify-content-center pt-3 gap-0 accordion-title-buttons"
          buttons={types.map((t) => ({
            label: t,
            variant: "outline-cyan",
            active: t === type,
            onclick: (e) => {
              e.preventDefault();
              setType(e.target.innerText);
            },
          }))}
        />
      )}
    </>
  );

  const accordions = (
    <>
      <Row>
        {computedItems.map((items, idx) => (
          <Col key={idx} xs={12} md={Math.floor(12 / columns)} className="flex-grow-1">
            <Accordions
              items={items.map((i) => ({
                name: i.question,
                description: <div dangerouslySetInnerHTML={{ __html: i.answer }} />,
              }))}
            />
          </Col>
        ))}
      </Row>
    </>
  );

  return (
    <div className={cn(className, classes.FAQs)} data-bs-theme={theme}>
      {fullWidth ? (
        <Container fluid="lg" className={columns === 1 ? "mw-xl" : null}>
          <div className="text-center">{intro}</div>
          {buttons}
          {accordions}
        </Container>
      ) : (
        <>
          <ParallaxBackground anim="y2n:x0:z0" image={bg_1} className={classes.bg_1} />
          <Container fluid="lg">
            {buttons}
            <Row>
              <Col xs={12} md={4}>
                {intro}
              </Col>
              <Col xs={12} md={8}>
                {accordions}
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
}
